module.exports = __webpack_public_path__ + "img/ug.be11ef39.svg";